import moment from "moment-timezone"
import { FEATURE_CINECLUB_DATE, FEATURE_PARTNERS, metadata } from "lacinetek-common/src/metadata"
import image, { PRODUCT_PHOTOGRAMME } from "lacinetek-common/src/images"

import { useTranslation } from "lib/i18n/translation"
import { FETCH_CATEGORY_VIDEO_PLAYER } from "lib/graphql"

import { Products, Query } from "components/common"
import Image from "components/common/image"
import SkeletonLink from "components/common/skeleton-link"
import { presentedSplitter } from "components/cine-club/intro"
import { partnerImage, partnerUrl } from "components/cine-club/description"

export const OtherOverlay = ({ club, index }) => {
	const { c } = useTranslation("common")

	return (
		<Products products={club.products.items}>
			{([film], loading) => {
				if (!film || loading) {
					return null
				}

				return (
					<div className="overlay-content">
						<section className="focus">
							<div className="infos">
								<h2 className="cine-club-title">{`CINE-CLUB #${index}`}</h2>
								<SkeletonLink href="/film/[id]" as={`/film/${film.linkRewrite}`}>
									<a title={c("see-singele-film")} className="film-link">
										<h3 className="title">{film.name}</h3>
										<div className="film-infos">
											<span className="director">{c("of")} {film.director}</span>
											<span className="duration">{film.duration}</span>
											<span className="year">{film.year}</span>
											<span className="country">{film.origin}</span>
										</div>
									</a>
								</SkeletonLink>
							</div>
							<figure className="background">
								<picture>
									<Image src={image(film, PRODUCT_PHOTOGRAMME)} alt={film.name} />
								</picture>
							</figure>
						</section>
						<section className="cine-club">
							<h2 className="hidden">{c("about-cineclub")}</h2>
							<div className="videoplayer youtube">
								<Query
									query={FETCH_CATEGORY_VIDEO_PLAYER}
									options={{ variables: { id: club.id } }}
									renderLoading={() => <div className="is-loading" />}
								>
									{({ cms: { categories: { items: [{ videos: { items: videos } }] } } }) => {
										if (videos.length == 0) return null

										const [{ player }] = videos
										return player ? <iframe src={player.url} /> : null
									}}
								</Query>
							</div>
							<div className="content">
								<div className="description" dangerouslySetInnerHTML={{ __html: club.description }} />
								<div className="excerpt">
									<p>{c("presented-by")} {presentedSplitter(club.descriptionShort, c)}</p>
									{
										metadata(club, FEATURE_CINECLUB_DATE) && moment(metadata(club, FEATURE_CINECLUB_DATE), "DD/MM/YYYY HH:mm").isValid()
											? <p>{c("broadcast-on")} <strong>{moment(metadata(club, FEATURE_CINECLUB_DATE), "DD/MM/YYYY hh:mm").format(`DD MMMM YYYY [${c("at")}] HH[h]mm`)}</strong></p>
											: null
									}
								</div>
								{
									metadata(club, FEATURE_PARTNERS)
									&& (
										<div className="in-collaboration">
											<p>{c("in-partnership-with")}</p>
											{metadata(club, FEATURE_PARTNERS).split(';').map((partner, index) => (
												<a
													key={`partner-link-${index}`}
													href={partnerUrl(partner)}
													target="_blank"
													aria-label={`${c("to-external-site")} ${partnerUrl(partner)}`}
													rel="nofollow noopener"
												>
													<span className="hidden">{c("external-link")}</span>
													<figure>
														<picture>
															<Image src={partnerImage(partner)} alt={partnerUrl(partner)} />
														</picture>
													</figure>
												</a>
											))}
										</div>
									)}
							</div>
						</section>
					</div>
				)
			}}
		</Products>
	)
}
